class NSSAccordionGroup extends HTMLElement {

  constructor() {
    super();

    this.debug = false;

    this.itemEls = this.querySelectorAll(`.nss-accordion-item`);
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][Accordion Group] Connected.");
    this.addEventListener(`click`, (e) => {
      if (e.target.parentElement.classList.contains(`nss-active`)) {
        this.closeAllItems();
      } else {
        this.closeAllItems();
        e.target.parentElement.classList.add(`nss-active`);
      }
    });
  }

  closeAllItems() {
    this.itemEls.forEach((itemEl) => {
      itemEl.classList.remove(`nss-active`);
    });
  }
}

let elementName = `nss-accordion-group`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSAccordionGroup);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}